import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import SubscriptionPaymentFailed from './SubscriptionPaymentFailed';

loadDOMComponent({
	selector: 'react-subscription-payment-failed',
	// @ts-ignore
	callback: ({ container, context, props }) => {
		const patientId = container.getAttribute('patientId');
		const isWidget = container.getAttribute('isWidget');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<SubscriptionPaymentFailed
						patientId={patientId}
						isWidget={isWidget}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
